import { render, staticRenderFns } from "./sortDown.vue?vue&type=template&id=6c66f586&scoped=true&"
import script from "./sortDown.vue?vue&type=script&lang=js&"
export * from "./sortDown.vue?vue&type=script&lang=js&"
import style0 from "./sortDown.vue?vue&type=style&index=0&id=6c66f586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66f586",
  null
  
)

export default component.exports